import { jsx as _jsx } from "react/jsx-runtime";
import { Copy, Optional } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from '../styles/Card.styles';
const SubTitleCopy = themeStyles.apply(Copy, 'SubTitleCopy');
const CardSubTitle = ({ alignment = 'center', subTitle }) => (_jsx(Optional, { when: subTitle, children: _jsx(SubTitleCopy, { alignment: alignment, "data-testid": "cy-uni-card-sub-title", children: subTitle }) }));
export default CardSubTitle;
